export function TiremetrixSearchTiresCtrl (
  $uibModalInstance,
  $scope,
  $timeout,
  $translate,
  domainParserApi,
  item,
  invoice,
  Invoice,
  messages,
  product,
  registeredTires,
  tires,
  Tiremetrix,
  workshopAPI
) {
  $scope.flipped             = false;
  $scope.references          = [];
  $scope.item                = item;
  $scope.loaded              = true;
  $scope.manual              = false;
  $scope.registrationsNeeded = item.quantity - registeredTires.length;
  $scope.product             = product;
  $scope.registeredTires     = registeredTires;
  $scope.tires               = tires;

  // IE specific properties to enable flipper modal compatibility
  $scope.IE         = domainParserApi.isInternetExplorer();
  $scope.Invoice    = new Invoice(invoice);
  $scope.Tiremetrix = new Tiremetrix();

  $scope.registeredTableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'tyre_identification_number',
        header : {
          text: $translate.instant('TIREMETRIX_SPACE.DOT')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TIRES')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'BaseTIN',
        header : {
          text: $translate.instant('TIREMETRIX_SPACE.BASE_TIN')
        }
      },
      {
        classes: 'text-left',
        field  : 'MSPN',
        header : {
          text: $translate.instant('TIREMETRIX_SPACE.MSPN')
        }
      },
      {
        classes: 'text-left',
        field  : 'TireBrand',
        header : {
          text: $translate.instant('TIREMETRIX_SPACE.TYRE_BRAND')
        }
      },
      {
        classes: 'text-left',
        field  : 'TireSize',
        header : {
          text: $translate.instant('VEHICLE_SPACE.TIRE_SIZE')
        }
      },
      {
        classes: 'text-left',
        field  : 'ModelName',
        header : {
          text: $translate.instant('TIREMETRIX_SPACE.MODEL_NAME')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TIRES')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.addManually = function () {
    $scope.manual     = true;
    $scope.references = [];

    $scope.tire = {
      ModelName: $scope.product.description,
      TireBrand: $scope.product.brand,
      TireSize : $scope.product.description2
    };

    for (let i = 0; i < $scope.registrationsNeeded; i++) {
      $scope.references.push({
        base_tin: null,
        tin_week: null,
        tin_year: null
      });
    }

    $scope.flip();
  };

  $scope.addRegistration = function () {
    $scope.Tiremetrix.searchTires($scope.invoice, $scope.item).then(() => {
      $uibModalInstance.close();
    });
  };

  $scope.defaultSelection = function () {
    if ($scope.tires.length) {
      $scope.tire = $scope.tires[0];

      for (let i = 0; i < $scope.registrationsNeeded; i++) {
        $scope.references.push({
          base_tin: $scope.tire.BaseTIN,
          week    : null,
          year    : null
        });
      }

      $scope.flip();
    }
    else {
      $scope.addManually();
    }
  };

  $scope.flip = function () {
    $scope.flipped = !$scope.flipped;

    $scope.$emit('flipModal');
  };

  $scope.onRegisteredRowClick = function ( tire ) {
    $scope.tire = tire;

    $scope.flip();
  };

  $scope.onTireRowClick = function ( tire ) {
    if (tire.selected) {
      $scope.manual     = false;
      $scope.references = [];
      $scope.tire       = tire;

      for (let i = 0; i < $scope.registrationsNeeded; i++) {
        $scope.references.push({
          base_tin: $scope.tire.BaseTIN,
          tin_week: null,
          tin_year: null
        });
      }

      tire.selected = false;

      $scope.flip();
    }
  };

  $scope.register = function() {
    $scope.Tiremetrix.registerTires($scope.Invoice.invoice)
    .then(() => {
      $uibModalInstance.close();
    });
  };

  $scope.save = function () {
    workshopAPI.post('/vehicle_tyre_registrations', {
      base_tin       : $scope.tire.BaseTIN,
      invoice_id     : $scope.Invoice.invoice.id,
      invoice_item_id: $scope.item.id,
      mspn           : $scope.item.item_code,
      product_id     : $scope.item.product_id,
      quantity       : 1,
      tyre_brand     : $scope.tire.TireBrand || '',
      tyre_codes     : $scope.references,
      tyre_model_name: $scope.tire.ModelName || '',
      tyre_size      : $scope.tire.TireSize || '',
      vehicle_id     : $scope.Invoice.invoice.vehicle_id
    }, 'vehicle_tyre_registration')
    .then(() => {
      messages.show($translate.instant('TIREMETRIX_SPACE.TYRE_REGISTRATIONS_SAVED'), 'success');

      $uibModalInstance.close();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.update = function () {
    workshopAPI.patch('/vehicle_tyre_registration', $scope.tire, 'vehicle_tyre_registration')
    .then(() => {
      messages.show($translate.instant('TIREMETRIX_SPACE.TYRE_REGISTRATIONS_UPDATED'), 'success');

      $uibModalInstance.close();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  if ($scope.tires.length <= 1) {
    $timeout(() => {
      $scope.defaultSelection();
    });
  }
}